<template>
  <v-overlay class="pa-12" :value="value" :opacity="0.9">
    <v-btn
        outlined
        color="white"
        class="rounded-lg"
        absolute
        style="top: -60px; right: 0px;"
        @click="$emit('input', false)"
    >Close
    </v-btn>
    <v-row class="overflow-y-auto">
      <v-col cols="6" sm="4" md="3" lg="2" xl="2" :key="tool.id" v-for="(tool) in filteredBrands">
        <v-card class="rounded-lg pa-4" light width="100%" :height="170" @click="selectTool(tool)">
<!--          <v-card-text>-->
            <v-row no-gutters justify="center" align="center" class="fill-height">
              <v-col cols="auto">
                <v-img
                    contain
                    width="100%"
                    :src="require(`@/assets/images/brand_logos/${tool.file}`)"
                ></v-img>
              </v-col>
            </v-row>
<!--          </v-card-text>-->
        </v-card>
      </v-col>
    </v-row>
  </v-overlay>
</template>

<script>
export default {
  name: "ToolSelector",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tools: {
      type: Array,
      required: true,
    },
    selectedTools: {
      type: Array,
      required: true,
    },
  },
  computed: {
    filteredBrands() {
      return this.tools.filter(({id}) => !this.selectedTools.includes(id));
    },
  },
  methods: {
    selectTool(tool) {
      this.$emit('select', tool);
    },
  },
  mounted() {
  },
}
</script>

<style scoped>

</style>